import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'access-llm',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // MODEL CONFIGURATION
    // No credentials required - uses platform system credential
    // Models are fetched dynamically from LiteLLM /v1/models endpoint
    // ==================================================================
    {
      key: 'model',
      label: 'Model',
      type: 'options',
      required: true,
      default: 'claude-haiku-4-5',
      optionsSource: 'litellmModels',
      description: 'Which AI model to use via LiteLLM proxy',
    },

    // ==================================================================
    // LLM PARAMETERS (Optional - leave empty to use defaults)
    // ==================================================================
    {
      key: 'temperature',
      label: 'Sampling Temperature',
      type: 'string',
      required: false,
      placeholder: 'e.g., 0.7',
      description: 'Controls randomness (0 = deterministic, 1 = creative)',
    },
    {
      key: 'maxTokens',
      label: 'Max Tokens',
      type: 'string',
      required: false,
      placeholder: 'e.g., 4096',
      description: 'Maximum tokens in the response',
    },
    {
      key: 'topP',
      label: 'Top P',
      type: 'string',
      required: false,
      placeholder: 'e.g., 1.0',
      description: 'Nucleus sampling threshold',
    },
    {
      key: 'frequencyPenalty',
      label: 'Frequency Penalty',
      type: 'string',
      required: false,
      placeholder: 'e.g., 0.0',
      description: 'Penalise repeated tokens (0 to 2)',
    },
    {
      key: 'presencePenalty',
      label: 'Presence Penalty',
      type: 'string',
      required: false,
      placeholder: 'e.g., 0.0',
      description: 'Penalise tokens based on presence in text so far (0 to 2)',
    },
  ],
};

export default schema;
